import { InvoicingAddressesController, InvoicingAddressesControllerProps } from './InvoicingAddresses.controller'

import { FC } from 'react'

/**
 * Presentation wrapper for {@link InvoicingAddressesController}.
 *
 * @remarks
 * This component acts as a thin abstraction layer over the controller,
 * allowing separation of container logic and public-facing component API.
 * It simply forwards all received props.
 *
 * Useful for keeping external imports stable if the internal controller
 * structure or implementation evolves later.
 *
 * @component
 * @example
 * ```tsx
 * <InvoicingAddresses
 *   onAddressSelect={(id) => console.log(id)}
 *   isEditable
 * />
 * ```
 */
export const InvoicingAddresses: FC<InvoicingAddressesControllerProps> = ({
  ...controllerProps
}) => {
  return (
    <InvoicingAddressesController {...controllerProps} />
  )
}
